<template>
<v-dialog v-model="showing" :width="400">
  <template #activator="{ on, attrs }">
    <v-btn v-on="on" v-bind="attrs" text>Add</v-btn>
  </template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Film</span>
    </v-card-title>

    <v-spacer />

    <v-card-text>
      <v-container class="text-center">
        <v-text-field label="imdb ID" v-model="imdb" />
        <v-alert v-if="error" type="error">{{ error }}</v-alert>
        <v-btn
          width="100%"
          color="success"
          class="mb-5"
          :loading="loading"
          :disabled="!imdb"
          @click="add"
        >Add</v-btn>
        <em v-if="loading">Please be patient, this may take a while...</em>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "AddDialog",
  data() {
    return {
      showing: false,
      loading: false,
      imdb: "",
      error: null,
    }
  },
  inject: ["httpClient"],
  methods: {
    async add() {
      if (this.loading) return
      this.loading = true
      this.error = null
      const response = await this.httpClient.addFilm({id: this.imdb})
      this.loading = false
      if (!response.success) {
        this.error = response.error || "Unknown Error"
      } else {
        this.showing = false
        this.error = null
        this.imdb = ""
        this.$router.push({name: "Film", params: {id: response.id}})
      }
    },
  },
}
</script>
